var _ellipse, _path, _path2, _ellipse2, _path3, _ellipse3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenLinkPublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.538,
    cy: 24.5917,
    rx: 7.82222,
    ry: 8.40806,
    stroke: "#13100D",
    strokeWidth: 1.83705
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3545 21.961L23.1884 27.5139",
    stroke: "#13100D",
    strokeWidth: 1.83705,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1885 21.9609L28.3545 27.514",
    stroke: "#13100D",
    strokeWidth: 1.83705,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.52192,
    cy: 8.10636,
    rx: 5.0522,
    ry: 5.43058,
    stroke: "#13100D",
    strokeWidth: 1.83705
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36035 23.5647C1.36035 18.0277 5.01426 13.5391 9.52159 13.5391C12.4243 13.5391 14.9731 15.4007 16.42 18.2051",
    stroke: "#13100D",
    strokeWidth: 1.83705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.569,
    cy: 5.13758,
    rx: 3.84929,
    ry: 4.13758,
    stroke: "#13100D",
    strokeWidth: 1.83705
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3506 16.916C16.3506 12.6973 19.1345 9.27734 22.5687 9.27734C24.8741 9.27734 26.8864 10.8186 27.9602 13.108",
    stroke: "#13100D",
    strokeWidth: 1.83705,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLinkPublic);
export default __webpack_public_path__ + "static/media/broken_link_public.16dba5cf0c537751d9d90331c2720074.svg";
export { ForwardRef as ReactComponent };